import React, { useState } from "react";
import { Helmet } from "react-helmet";

import "../../assets/css/css_reset_nerdweb.css";
import "../../assets/css/css_header.css";
import "../../assets/css/css_content.css";
import "../../assets/css/css_footer.css";
import "../../assets/css/css_content_carousel.css";

import Logo from "../../assets/hotsite/js_studio_de_danca_logo_txt.svg";
import LogoFooter from "../../assets/hotsite/logo_jsstudio_de_danca.png";

function Politica() {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleMenuOpen = () => {
    setMenuOpen(true);
  };

  const handleMenuClose = () => {
    setMenuOpen(false);
  };

  return (
    <div className="site">
      <Helmet>
        <title>5ª Mostra JS Studio de Dança</title>

        <meta charSet="utf-8" />
        <meta httpEquiv="X-UA-Compatible" content="IE=edge,chrome=1" />
        <meta
          name="description"
          content="Ideias Promissoras, Projetos Acelerados, Resultados Reais"
        />
        <meta
          name="keywords"
          content="palavra chave, palavra chave, palavra chave, palavra chave, palavra chave, palavra chave, palavra chave"
        />
        <meta name="REVISIT-AFTER" content="1 DAYS" />
        <meta name="dcterms.audience" content="GLOBAL" />
        <meta name="AUTHOR" content="Cowmeia" />
        <meta name="dcterms.rightsHolder" content="Copyright (c) Nerdweb" />
        <meta name="dc.language" content="pt-br" />
        <meta name="RATING" content="GENERAL" />
        <meta name="Robots" content="INDEX,FOLLOW" />
        <meta name="format-detection" content="telephone=no" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1, minimum-scale=1"
        />
        <meta name="SKYPE_TOOLBAR" content="SKYPE_TOOLBAR_PARSER_COMPATIBLE" />

        {/* FACEBOOK */}
        <meta property="og:site_name" content="JS Studio de Dança" />
        <meta property="og:title" content="JS Studio de Dança" />
        <meta property="og:description" content="DESCRICAO DO SITE" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.jsstudiodedanca.com.br/" />
        <meta
          property="og:image"
          content="https://www.jsstudiodedanca.com.br/js-studio-facebook.jpg"
        />
        <meta property="og:image:type" content="image/jpeg" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />

        {/* Google Fonts */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link
          rel="preconnect"
          href="https://fonts.gstatic.com"
          crossOrigin="true"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap"
          rel="stylesheet"
        />

        {/* Font Awesome */}
        <link
          rel="stylesheet"
          href="https://use.fontawesome.com/releases/v6.4.0/css/all.css"
        />

        {/* Favicon */}
        <link rel="shortcut icon" type="image/x-icon" href="favicon.ico" />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="favicon_32x32.png"
        />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="favicon_180x180.ico"
        />
      </Helmet>

      {/* HEADER */}
      <header id="header" className="header-bg-full">
        <div className="bar-header">
          <div className="bar-center-header">
            <div className="menu">
              <ul>
                <li>
                  <a
                    href="https://api.whatsapp.com/send?phone=5541992464090"
                    title="Enviar mensagem no WhatsApp da JS Studio"
                  >
                    <i className="fa-brands fa-whatsapp"></i> +55 (41)
                    99246-4090
                  </a>
                </li>
                <li>
                  <a
                    href="https://api.whatsapp.com/send?phone=5541992464090"
                    title="Fale Conosco"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    FALE CONOSCO
                  </a>
                </li>
                <li>
                  <a
                    href="https://app.beeventz.com.br/"
                    title="Sistema de Eventos JS Studio de Dança"
                  >
                    MINHA CONTA
                  </a>
                </li>
              </ul>
            </div>
            <div className="redes-sociais">
              <ul>
                <li>
                  <a
                    href="https://www.instagram.com/jsstudiodedanca/"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Instagram JS Studio de Dança"
                  >
                    <i className="fa-brands fa-instagram"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.tiktok.com/@jsstudiodedanca"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Tik Tok JS Studio de Dança"
                  >
                    <i className="fa-brands fa-tiktok"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.facebook.com/JSStudiodeDanca/"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Facebook JS Studio de Dança"
                  >
                    <i className="fa-brands fa-facebook-f"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/channel/UC9pcKChidSY2reUlzG38f7A?view_as=subscriber"
                    target="_blank"
                    rel="noopener noreferrer"
                    title=""
                  >
                    <i className="fa-brands fa-youtube"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.linkedin.com/company/jsstudiodedanca"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Linkedin JS Studio de Dança"
                  >
                    <i className="fab fa-linkedin"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="center-header">
          {/* LOGO */}
          <div className="logo arrow-topo" data-href="#header">
            <a href="/">
              <img className="logo-full" src={Logo} alt="JS Studio de Dança" />
            </a>
          </div>

          <div className="box-nav">
            <div className="container">
              <div
                id="trigger-overlay"
                className="menu-mobile"
                onClick={handleMenuOpen}
              >
                <i className="fas fa-bars"></i>
              </div>
            </div>
            <nav className="nav-web">
              <ul>
                <li>
                  <a
                    className="arrow-topo"
                    data-href="#header"
                    href="/"
                    title=""
                  >
                    HOME
                  </a>
                </li>
                <li>
                  <a
                    href="#link-valores"
                    title="Valores dos Ingressos para Mostra JS Studio"
                  >
                    VALORES
                  </a>
                </li>
                <li>
                  <a href="#link-infos" title="Informações Sobre o Evento">
                    EVENTO
                  </a>
                </li>
                <li>
                  <a href="#link-local" title="Endereço do Teatro Positivo">
                    LOCAL
                  </a>
                </li>
              </ul>
            </nav>
            <div className="nav-sites">
              <ul>
                <li>
                  <a
                    href="https://jsstudiodedanca.com.br/inscricao-7-mostra-js-studio"
                    title="Comprar Ingresso"
                  >
                    COMPRAR INGRESSO
                  </a>
                </li>
              </ul>
            </div>

            <div
              className={`overlay overlay-contentpush ${
                menuOpen ? "open" : ""
              }`}
            >
              <button
                type="button"
                className="overlay-close"
                onClick={handleMenuClose}
              >
                Close
              </button>
              <nav className="nav-mobile">
                <ul>
                  <li>
                    <a
                      className="arrow-topo"
                      data-href="#header"
                      href="/"
                      title=""
                      onClick={handleMenuClose}
                    >
                      HOME
                    </a>
                  </li>
                  <li>
                    <a
                      href="#link-valores"
                      title="Valores dos Ingressos para Mostra JS Studio"
                      onClick={handleMenuClose}
                    >
                      VALORES
                    </a>
                  </li>
                  <li>
                    <a
                      href="#link-infos"
                      title="Informações Sobre o Evento"
                      onClick={handleMenuClose}
                    >
                      EVENTO
                    </a>
                  </li>
                  <li>
                    <a
                      href="#link-local"
                      title="Endereço do Teatro Positivo"
                      onClick={handleMenuClose}
                    >
                      LOCAL
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://api.whatsapp.com/send?phone=5541992464090"
                      title="Fale Conosco"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      FALE CONOSCO
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://app.beeventz.com.br/"
                      title="Sistema de Eventos JS Studio de Dança"
                      onClick={handleMenuClose}
                    >
                      MINHA CONTA
                    </a>
                  </li>
                  <li className="cta-menu">
                    <a
                      href="https://jsstudiodedanca.com.br/inscricao-7-mostra-js-studio"
                      title="Comprar Ingresso"
                      onClick={handleMenuClose}
                    >
                      COMPRAR INGRESSO
                    </a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </header>

      <section class="politica-bloco-01">
        <div class="center-content">
          <h2>
            <span>TERMOS DE USO &amp;</span>POLÍTICA DE PRIVACIDADE
          </h2>
          <p>JS Studio Produções LTD ("JS Studio de Dança")</p>

          <h3>TERMOS &amp; POLÍTICAS DE USO DO SITE</h3>
          <p>
            <strong>Identificação da Empresa:</strong> JS Studio Produções LTD,
            doravante denominada "JS Studio de Dança", inscrita no CNPJ nº
            33.637.559/001-86, opera o website acessível pelo endereço{" "}
            <a
              href="https://jsstudioeventos.com.br"
              title="Site JS Studio Eventos"
            >
              https://jsstudioeventos.com.br
            </a>
            , incluindo todas as suas páginas e subdomínios. A plataforma tem
            como objetivo facilitar a aquisição e também realizar vendas de
            ingressos para eventos próprios e inscrições em eventos de
            terceiros.
          </p>

          <p>
            <strong>Aceitação dos Termos:</strong> Ao acessar e utilizar os
            serviços oferecidos pela JS Studio de Dança, você concorda em
            vincular-se aos seguintes termos e condições, que poderão ser
            atualizados periodicamente sem aviso prévio. É recomendável revisar
            regularmente os termos atualizados.
          </p>

          <h3>1. Registro e Uso da Conta:</h3>
          <p>
            <strong>Dados do Usuário:</strong> Ao registrar-se, você se
            compromete a fornecer informações precisas e atualizadas. A JS
            Studio de Dança reserva-se o direito de solicitar comprovações e, se
            necessário, suspender ou encerrar contas com dados falsos.
          </p>
          <p>
            <strong>Segurança da Conta:</strong> A manutenção da
            confidencialidade da senha e do nome de usuário é de sua inteira
            responsabilidade. Qualquer atividade sob sua conta deve ser
            imediatamente reportada caso haja uso indevido.
          </p>

          <h3>2. Compra e Uso de Ingressos:</h3>
          <p>
            É imperativo fornecer dados corretos ao comprar ingressos. A JS
            Studio de Dança não se responsabiliza por compras inválidas devido a
            informações incorretas.
          </p>
          <p>
            O comprador é responsável pelo pagamento integral via os métodos
            disponíveis e deve respeitar os termos de uso e segurança dos
            ingressos adquiridos, tanto para eventos organizados pela JS Studio
            de Dança quanto por terceiros.
          </p>

          <h3>3. Privacidade e Tratamento de Dados:</h3>
          <p>
            <strong>Coleta de Dados:</strong> Coletamos informações necessárias
            para a realização de compras e inscrições, bem como dados
            não-identificáveis para análise e melhoria do serviço.
          </p>
          <p>
            <strong>Uso de Dados:</strong> Os dados coletados são utilizados
            para gestão de contas, atendimento ao cliente, análise de operações
            e comunicações de marketing, desde que haja consentimento do
            usuário.
          </p>
          <p>
            <strong>Compartilhamento de Dados:</strong> Informações pessoais
            podem ser compartilhadas com prestadores de serviços e parceiros
            confiáveis, sob a condição de confidencialidade e segurança.
          </p>
          <p>
            <strong>Segurança nas Transações Financeiras:</strong> Por motivos
            de segurança, a JS Studio de Dança não armazena nenhuma informação
            referente a formas de pagamento. Para processar pagamentos,
            utilizamos ferramentas especializadas fornecidas por terceiros,
            especificamente o "PagBank da Empresa PagSeguro" (
            <a href="https://pagseguro.uol.com.br" title="PagSeguro">
              https://pagseguro.uol.com.br
            </a>
            ) e "Pagar.me da empresa Stone" (
            <a href="https://pagar.me" title="Pagar.me">
              https://pagar.me
            </a>
            ), que são plataformas seguras e especializadas em transações
            financeiras online.
          </p>

          <h3>4. Direitos do Titular dos Dados:</h3>
          <p>
            Os usuários podem exercer seus direitos de acesso, correção,
            cancelamento e oposição conforme previsto na Lei Geral de Proteção
            de Dados (LGPD).
          </p>

          <h3>5. Cookies e Tecnologias Similares:</h3>
          <p>
            Utilizamos cookies para melhorar a experiência do usuário, oferecer
            serviços personalizados e garantir a segurança do site.
          </p>

          <h3>6. Modificações nos Termos e na Política de Privacidade:</h3>
          <p>
            Reservamo-nos o direito de modificar os termos e políticas
            periodicamente. A continuidade do uso dos serviços após tais
            alterações constitui aceitação dos novos termos.
          </p>

          <h3>7. Disposições Gerais:</h3>
          <p>
            <strong>Resolução de Disputas:</strong> Eventuais disputas serão
            primariamente resolvidas amigavelmente e, se necessário, submetidas
            à jurisdição dos tribunais de Curitiba, Paraná.
          </p>
          <p>
            <strong>Limitação de Responsabilidade:</strong> A JS Studio de Dança
            não se responsabiliza por eventos organizados por terceiros e
            quaisquer consequências decorrentes de tais eventos. Igualmente,
            asseguramos que a venda de ingressos para eventos próprios é
            realizada com a mesma garantia de qualidade e segurança.
          </p>

          <h3>
            Ao utilizar o site e serviços da JS Studio de Dança, você reconhece
            que leu e concordou com os termos aqui estabelecidos.
          </h3>
        </div>
      </section>

      {/* FOOTER */}
      <footer>
        <div className="center-footer">
          {/* LOGO */}
          <div className="logo arrow-topo" data-href="#header">
            <a href="/">
              <img src={LogoFooter} alt="JS Studio de Dança" />
            </a>
          </div>

          <div className="box-infos">
            <div className="informacoes">
              <ul>
                <li>
                  <h4>ATENDIMENTO</h4>
                  <p>
                    <a
                      href="https://api.whatsapp.com/send?phone=5541992464090"
                      title=""
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fa-brands fa-whatsapp"></i> +55 (41)
                      99246-4090
                    </a>
                  </p>
                  <p>
                    <i className="fa-solid fa-phone"></i> +55 (41) 99246-4090
                  </p>
                  <p>
                    <a href="mailto:contato@jstudiodedanca.com.br">
                      contato@jstudiodedanca.com.br
                    </a>
                  </p>
                </li>
                <li>
                  <h4>CONTATO</h4>
                  <p>Seg a Sex: 14:00 às 22:00</p>
                  <p>Sábado: 09:00 às 16:30</p>
                  <p>Feriados: Consultar Horários</p>
                </li>
                <li>
                  <h4>ENDEREÇO</h4>
                  <p>
                    Rua Augusto Stresser, 1745, Hugo Lange Curitiba, Paraná,
                    Brasil | CEP: 80.030-340
                  </p>
                  <p>
                    <a
                      href="https://www.google.com.br/maps/place/JS+Studio+de+Dan%C3%A7a/@-25.4175124,-49.2467646,17z/data=!3m1!4b1!4m5!3m4!1s0x94dce5e3361d4147:0xe33dfbddf1319b3!8m2!3d-25.4175173!4d-49.2445759"
                      title=""
                      target="_blank"
                      rel="noopener noreferrer"
                      className="btn-chegar"
                    >
                      Como Chegar
                    </a>
                  </p>
                </li>
              </ul>
            </div>

            <div className="box-links">
              <div className="menu">
                <ul>
                  <li>
                    <a
                      href="/politica-de-privacidade/"
                      title="Política de Privacidade"
                    >
                      POLÍTICA DE PRIVACIDADE
                    </a>
                  </li>
                  <li>
                    <a
                      href="/perguntas-frequentes"
                      title="Perguntas Frequentes"
                    >
                      PERGUNTAS FREQUENTES
                    </a>
                  </li>
                  <li className="btn-msg">
                    <a
                      href="https://app.beeventz.com.br/"
                      title="Sistema de Eventos JS Studio de Dança"
                    >
                      MINHA CONTA
                    </a>
                  </li>
                </ul>
              </div>
              <div className="redes-sociais">
                <ul>
                  <li>
                    <a
                      href="https://www.instagram.com/jsstudiodedanca/"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Instagram JS Studio de Dança"
                    >
                      <i className="fa-brands fa-instagram"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.tiktok.com/@jsstudiodedanca"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Tik Tok JS Studio de Dança"
                    >
                      <i className="fa-brands fa-tiktok"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.facebook.com/JSStudiodeDanca/"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Facebook JS Studio de Dança"
                    >
                      <i className="fa-brands fa-facebook-f"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.youtube.com/channel/UC9pcKChidSY2reUlzG38f7A?view_as=subscriber"
                      target="_blank"
                      rel="noopener noreferrer"
                      title=""
                    >
                      <i className="fa-brands fa-youtube"></i>
                    </a>
                  </li>
                  <li>
                    <a
                      href="https://www.linkedin.com/company/jsstudiodedanca"
                      target="_blank"
                      rel="noopener noreferrer"
                      title="Linkedin JS Studio de Dança"
                    >
                      <i className="fab fa-linkedin"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div className="copyright">
            <div className="box-txt">
              <p>
                © 2024 - JS Studio de Dança.{" "}
                <span className="direitos">Todos os Direitos Reservados.</span>
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default Politica;
